
import sitecfg from '@/sitecfg.js'

const data_bus = {
  state: {

    // 选中要卖出的狮子
    data_on_sell: null,

    // 选中的公马，用在 bread 按钮出价弹框
    data_on_breed: null,

    // 选中公马，用来选我的母马配马
    data_on_select_mate: null,
    // 选中我的母马，用来配马
    data_on_select_mate_female: null,

    // 选中新马，取名
    data_on_give_name: null,

    // popupShowNewBorn
    data_popup_show_new_born: null,
    // popupShowNewDraw
    data_popup_show_new_draw: null,

    // race
    data_on_select_to_race: null,
    data_on_select_to_race_position: null,
  },
  mutations: {
    setDataBusKey(state,obj){
      for (let key in obj) {
        state[key] = obj[key];
      }
    },
  },
}

export default data_bus